import express from 'express';
import { handleMyOperatorWebhook } from '@/modules/myoperator/myoperator.webhook.controller';

const router = express.Router();

router.post('/', handleMyOperatorWebhook);

export default router;
